import { FormattedMessage } from 'react-intl';

import { TourStopList } from '#components/tourdetails/TourStopList.tsx';
import type { Tour } from '#domain/model/Tour.ts';
import type { ExpanderListItemBase } from '#utils/util.ts';

type TourExpanderItemsProps = {
    tour: Tour;
    selectedItemIndex: number | undefined;
    setSelectedItemIndex: (index: number | undefined) => void;
    setSelectedStopId: (stop?: string) => void;
};

export const getTourExpanderItems = ({
    tour,
    setSelectedItemIndex,
    selectedItemIndex,
    setSelectedStopId,
}: TourExpanderItemsProps) => {
    const expanderItems: ExpanderListItemBase[] = [];

    const tourStopsItem: ExpanderListItemBase = {
        id: 'tour-stops',
        header: <FormattedMessage data-testid={'tour-stops-div'} id={'intl-msg:ordercom-cloud-frontend.tour.stops'} />,
        body: <TourStopList tour={tour} setSelectedStopId={setSelectedStopId} />,
    };

    expanderItems.push(tourStopsItem);

    return expanderItems.map((item, index) => ({
        ...item,
        open: selectedItemIndex === index,
        onOpen: () => setSelectedItemIndex(index),
        onClose: () => setSelectedItemIndex(undefined),
        bodyClassName: 'padding-top-0',
    }));
};
